module.exports = __webpack_public_path__ + "static/mobilenav-closeforward-do-44ba364666cbf220648fc18c8ec1e036.png";